import * as React from 'react';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import _get from 'lodash/get';
import {action, observable} from 'mobx';
import {IWidgetComponentProps} from '@mintdata-wsp/wsp/ui/views/visualDesigner/flow/panels/properties/widgets/FlowPropertiesWidgets';
import {PropertyError} from '@mintdata-wsp/wsp/ui/views/visualDesigner/flow/panels/properties/widgets/common/PropertyError';
import {IItemRendererProps} from '@mintdata/mint-kit/impl/properties/components/suggest/common/ListItemsProps';
import {QueryListUtils} from '@mintdata/mint-kit/impl/properties/components/suggest/QueryListUtils';
import {MultiSuggest} from '@mintdata/mint-kit/impl/properties/components/suggest/MultiSuggest';
import {IPillInputProps} from '@mintdata/mint-kit/impl/properties/components/pillInput/PillInput';
import {IInputEditProps} from '@mintdata/mint-kit/impl/properties/components/inputEdit/InputEdit';

const styles = require('@mintdata/mint-kit/impl/properties/components/suggest/QueryList.less');
const cx = classnames.bind(styles);

@observer
export class FrameColumnNamesWidget extends React.Component<IWidgetComponentProps, any>
{
    @observable
    private isDirty:boolean;

    public static defaultProps:Partial<IWidgetComponentProps> = {
        isOutlined: true,
    };

    constructor(props:IWidgetComponentProps)
    {
        super(props);

        const {isDirty} = props;

        this.isDirty = (isDirty !== undefined) ? isDirty : false;
    }

    @action
    componentWillReceiveProps({isDirty}:IWidgetComponentProps)
    {
        if( isDirty !== undefined )
        {
            this.isDirty = isDirty;
        }
    }

    render()
    {
        const {
            prop,
            inlineLabel,
            isOutlined,
            error,
            frameColumnNames,
            onRef,
        } = this.props;

        const {value: values = []} = prop;
        const errors = this.isDirty ? _get(error, 'messages', []) : [];

        const pillInputProps:Partial<IPillInputProps> = {
            inputProps: {
                label: inlineLabel,
                isOutlined,
                isInvalid: errors.length > 0,
                validationError: errors[0],
                onRef,
            } as Partial<IInputEditProps>,
            onRemove: this._handleItemRemove,
        };

        const FrameColumnsSuggest = MultiSuggest.ofType<string>();

        return (
            <div>
                <FrameColumnsSuggest
                    items={frameColumnNames}
                    selectedItems={values}
                    onItemSelect={this._handleItemSelect}
                    pillInputProps={pillInputProps}
                    itemRenderer={this._itemRenderer}
                    itemListPredicate={this._itemListPredicate}
                    isEditable={true}
                    resetQueryOnSelect={true}
                />
            </div>
        );
    }

    private _itemListPredicate = (query:string, items:string[]) =>
    {
        return items.filter((item) => item.toLowerCase().indexOf(query.toLowerCase()) >= 0);
    };

    private _itemRenderer = (item:string, itemProps:IItemRendererProps) =>
    {
        const {handleClick, modifiers, query} = itemProps;
        const {active} = modifiers;
        const listItemSelected = this._isItemSelected(item);

        return (
            <div
                className={cx(styles.listItem, {listItemActive: active, listItemSelected})}
                key={item}
                onMouseDown={handleClick}
            >
                <div className={styles.listItemText}>
                    {QueryListUtils.highlightText(item, query)}
                </div>
            </div>
        );
    };

    @action
    private _handleItemSelect = (item:string) =>
    {
        if( !this._isItemSelected(item) )
        {
            this._selectItem(item);
        }
        else
        {
            this._deselectItem(item);
        }
    };

    @action
    private _handleItemRemove = (_item:string, index:number) =>
    {
        const {prop} = this.props;
        const {value: values = []} = prop;

        const item = values.find((_, i) => i === index);
        this._deselectItem(item);
    };

    private _isItemSelected(item:string):boolean
    {
        const {prop} = this.props;
        const {value: values = []} = prop;

        return values.indexOf(item) !== -1;
    };

    @action
    private _selectItem(item:string)
    {
        const {prop, onChange} = this.props;
        const {value: values = []} = prop;

        onChange([...values, item]);

        this._maybeSetIsDirty();
    }

    @action
    private _deselectItem(item:string)
    {
        const {prop, onChange} = this.props;
        const {value: values = []} = prop;

        onChange(values.filter(value => value !== item));

        this._maybeSetIsDirty();
    }

    @action
    private _maybeSetIsDirty()
    {
        const {isDirty} = this.props;

        if( isDirty === undefined && this.isDirty !== true )
        {
            this.isDirty = true;
        }
    }
}
